import React from 'react';
import { Props } from './props';

export const Divider: React.FC<Props> = (props) => {
  const { haveMargin, style } = props;
  return (
    <div className={`w-full bg-gray-200 ${haveMargin && 'my-4'}`} style={{ height: 1, ...style }} />
  );
};
